<template>
  <div class="home_view right_auth">
    <div class="top">
      <div class="left">
        <router-link class="userInfoLink" :to="{name:'InfoView'}">
          <span class="text">查看</span>
          <img :src="userInfo.userHead ? (API.IMG + userInfo.userHead) : 'http://123.57.173.46:8089/public/2017/08/05/1/upic_0.png'" alt="">
        </router-link>
        <p class="name ellipsis"> {{userInfo.userPetname || '深度用户'}}</p>
      </div>
      <div class="right">
        <p class="balance"><span>我的钱包</span> <router-link :to="{name:'RechargeView'}" class="charge">充值</router-link> </p>
        <div class="numbers">
          <div class="price">  <span>¥{{userInfo.userMoney || 0}}</span>  <span>余额</span>  </div>
          <div class="price">  <span>{{userInfo.discountList ? userInfo.discountList.length:0}}张</span>  <span>优惠券</span>  <router-link :to="{name:'CouponView'}">查看</router-link> </div>
          <div class="price">  <span>{{collectCount?collectCount:0}}</span>  <span>我的收藏</span>  <router-link :to="{name:'CollectView'}">查看</router-link> </div>
          <div class="price integral">  <span>{{userInfo.integral || 0}}</span>  <span class="clearfix wrap">积分<span class="aside">
            <i>?</i>
            <span class="text">所有注册用户参与评价、点赞、收藏等活动，可获得深度积分。深度配音将不定期推出积分优惠活动，敬请期待！</span>
          </span>
          </span> </div>
          <div class="price grade">
            <div class="gradeTop">
              <span class="gradeNum">{{ integralInfo.rank }}</span><span class="name">{{ integralInfo.name }}</span>
            </div>
            <div class="titleWrap clearfix">
              <small>等级</small><div class="aside">
              <i>?</i>
              <table class="table">
                <colgroup><col><col><col><col><col><col><col></colgroup>
                <tr class="hd">
                  <td>等级</td>
                  <td>积分</td>
                  <td>称号</td>
                </tr>
                <tr v-for="item in ruleTable">
                  <td>{{item.rank}}</td>
                  <td>{{item.grade}}</td>
                  <td>{{item.name}}</td>
                </tr>
              </table>
              </div>
            </div>
            <span class="bottomWrap">距离下一等级还差<b class="num">{{integralGap}}</b>积分</span> </div>
        </div>

      </div>
    </div>
    <div class="bottom">
      <div class="title">
        <p class="fl">近期订单</p>
        <router-link :to="{name: 'OrderView'}" class="rt">查看全部订单</router-link>
      </div>

      <div class="content">
        <div class="g_empty" v-if="orderData.length == 0">
          <p class="info">暂无订单信息，快去挑选合适的声音吧 ~</p>
        </div>
        <div v-if="orderData.length">

          <!-- 订单cell -->
          <table v-for="item in orderData" class="order_tb">
            <colgroup>
              <col class="name_col">
              <col class="priority_col">
              <col class="teacher_col">
              <col class="pricing_col">
              <col class="pay_col">
              <col class="state_col">
              <col class="operate_col">
            </colgroup>
            <tbody>
            <tr class="tr-th">
              <td colspan="8">
                                <!--<span class="number">-->
                                    <!--订单编号：<a target="_blank" >{{item.orderNum}}</a>-->
                                <!--</span>-->
                <span class="dealtime">创建时间：{{item.createTime}}</span>
                <div class="invoiced" v-if="item.invoiceId"></div>
              </td>
            </tr>
            <tr class="tr-br">
              <!-- 稿件 -->
              <td >稿件名称</td>
              <td>紧急</td>
              <td>选定老师</td>
              <td >定价</td>
              <td >实际付款</td>
              <td>订单状态</td>
              <td class="operate" style="border-right: 1px solid #e2e2e2;">操作</td>
            </tr>
            <tr>
              <!-- 稿件 -->
              <!--<td :class="canDownContribution(item)?'down-load':''" -->
              <!--@click="downContribution(item)"-->
              <!--:href="item.realPath"-->
              <!---->
              <!--class="blue">{{item.contributionName}}-->
              <!--</td>-->
              <td>
                <a :class="canDownContribution(item)?'down-load':''"
                   @mouseenter.once="downContribution(item)"

                   class="blue"
                   :href="item.realPath || 'javascript:;'"
                   target="_blank"
                   :disabled="!item.realPath">{{item.contributionName}}
                              </a>
              </td>
              <td>{{_options.pressingStatus[item.pressingStatus]}}</td>
              <td>{{item.dubboNum}}</td>
              <td class="red">{{item.appointPrice}}</td>
              <td class="red">{{item.realityPrice}}</td>
              <td>
                <i class="demand on" v-jq-tips="'已需求'"></i>
                <i class="demo" :class="{on:item.auditionIds}" v-jq-tips="item.auditionIds?'已有老师试音，查看试音详情请点击右侧‘查看试音’':'尚无老师试音'"></i>
                <i class="pay" :class="{on:item.payId}" v-jq-tips="item.payId?'已经支付订单费用':'订单尚未支付'"></i>
                <i class="finished" :class="{on:item.productId || item.voiceLength}" v-jq-tips="(item.productId || item.voiceLength)?'已经录制成品':'尚未录制成品'"></i>
                <i class="canceled" v-if="item.orderStatus == 10" v-jq-tips="'已取消'"></i>
              </td>
              <td class="operate" style="border-right: 1px solid #e2e2e2;">
                <button class="paybtn" v-if="canPay(item)" @click="singlePay(item)">立即支付</button>
                <a v-if="canAudition(item)" @click="voiceList(item.auditionIds)">查看试音</a>
                <router-link :to="{name:'Discuss',query:{ id:item.orderNum }}" class="discuss" v-if="item.payId">{{item.dubbingGrade?'查看评论':'评价订单'}}</router-link>
                 <!--<a v-if="canDownContribution(item)" @click="downContribution(item)" target="_blank">下载稿件</a>-->
              </td>
            </tr>
            </tbody>
          </table>
          <!-- 试音列表 -->
          <sd-modal v-show="viewVoice">
            <div class="demo_voice">
              <div class="title">您的试音
                              <i class="close" @click="viewVoice = false"></i>
              </div>
              <div class="content">
                <ul>
                  <li v-for="(vo, index) in voiceLists" :sound-id="vo.id">
                    <a class="number" href="javascript:;">{{index+1}}</a>
                    <a class="dubber" href="javascript:;">{{vo.auditionDubboNum+'号'}}</a>
                    <a class="voice"  href="javascript:;" :title="vo.auditionName">{{vo.auditionName}}</a>
                    <i class="play sound-play"></i>
                  </li>
                </ul>
              </div>
            </div>
          </sd-modal>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {util} from '../service/util'
  import { service } from '../service/service'
  import { mapState, mapActions, mapGetters} from 'vuex'
  import sdModal from '../components/sdModal.vue'
  let API = util.api(['GETCUSTOMERINFO', 'FINDMYORDER', 'FINDMYAUDITION', 'GETCONTRIBUTIONBYID'])
  export default{
    components: { sdModal },
    data () {
      return {
        API: API,
        orderData: [],
        // 显示试音列表
        viewVoice: false,
        // 试音列表数据
        voiceLists: [],
        // 积分区间
        integralSection: ['0-100', '101-500', '501-1200', '1201-2500', '2501-5000', '5001-8000', '8001-12000', '12001-20000', '20001-30000', '30001-50000', '50001-80000', '80001-120000', '120001-200000', '200001-300000', '300001-Infinity'],
        integral: 1,
        integralGap: 0,
        integralIcon: '1心',
        ruleTable: [
          {
            rank: 1,
            grade: '1-100',
            actor: '1心',
            name: '配音菜鸟'
          },
          {
            rank: 2,
            grade: '101-500',
            actor: '2心',
            name: '配音先驱'
          },
          {
            rank: 3,
            grade: '501-1200',
            actor: '3心',
            name: '配音大虾'
          },
          {
            rank: 4,
            grade: '1201-2500',
            actor: '4心',
            name: '配音老鸟'
          },
          {
            rank: 5,
            grade: '2501-5000',
            actor: '5心',
            name: '配音进阶'
          },
          {
            rank: 6,
            grade: '5001-8000',
            actor: '1钻',
            name: '配音中阶'
          },
          {
            rank: 7,
            grade: '8001-12000',
            actor: '2心',
            name: ' 配音高阶'
          },
          {
            rank: 8,
            grade: '12001-20000',
            actor: '3钻',
            name: '配音学士'
          },
          {
            rank: 9,
            grade: '20001-30000',
            actor: '4钻',
            name: '配音硕士'
          },
          {
            rank: 10,
            grade: '30001-50000',
            actor: '5钻',
            name: '配音博士'
          },
          {
            rank: 11,
            grade: '50001-80000',
            actor: '1皇冠',
            name: '配音狂人'
          },
          {
            rank: 12,
            grade: '80001-120000',
            actor: '2皇冠',
            name: ' 配音达人'
          },
          {
            rank: 13,
            grade: '120001-200000',
            actor: '3皇冠',
            name: '配音至尊'
          },
          {
            rank: 14,
            grade: '200001-300000',
            actor: '4皇冠',
            name: '配音之神'
          },
          {
            rank: 15,
            grade: '300001-',
            actor: '5皇冠',
            name: '配音大圣'
          }
        ]
      }
    },
    computed: {
      collectCount () {
        if (this.userInfo.collectMap) {
          let _this = this
          let arr = Object.values(_this.userInfo.collectMap)
          let sum = 0
          for (let i = 0; i < arr.length; i++) {
            sum += arr[i].length
          }
          return sum
        } else {
          return 0
        }
      },
      discountCount () {
        if (this.userInfo.discountList) {
          return this.userInfo.discountList.length
        }
        return 0
      },
      ...mapState({
        _options: state => state.common.options,
        userInfo: state => state.common.userInfo
      }),
      integralInfo () {
        return this.ruleTable[this.integral - 1]
      }
    },
    methods: {
      // 可下载稿件
      canDownContribution (item) {
        return item.contributionId
      },
      // 下载稿件
      downContribution (r) {
        if (!r.contributionId) {
          return
        }
        util.kAjax(API.GETCONTRIBUTIONBYID, {id: r.contributionId}, function (json) {
          // r.realPath = 'http://d.sd235.net/' + json.data.contributionServerPath
          r.realPath = 'https://transaction.oss-cn-shanghai.aliyuncs.com/' + json.data.contributionServerPath
        }, function (err) {

        }, true)
      },
      // 可支付
      canPay (item) {
        return item.orderStatus == 3 || (item.orderStatus > 3 && item.orderStatus != 10 && !item.payId)
      },
      // 可查询试音
      canAudition (item) {
        return item.auditionIds
      },
      /**
       * 单个支付
       */
      singlePay (item) {
        let orders = [item]
        this.$store.commit('PAYORDERS', orders)
        this.$router.push({
          name: 'PayView'
        })
      },
      // 查看试音
      voiceList (_ids) {
        let ids = _ids.split(',')
        util.kAjax(API.FINDMYAUDITION, {ids: ids}, res => {
          this.viewVoice = true
          util.addSoundData(res.data)
          this.voiceLists = res.data
        })
      }
    },
    watch: {
      userInfo () {
        let num = this.userInfo.integral
        let arr = ['1-5-心', '6-10-钻', '11-15-皇冠']
        this.integralSection.map((item, index) => {
          let minnum = item.split('-')[0] - 0
          let maxnum = item.split('-')[1] - 0
          if (minnum <= num && num <= maxnum) {
            this.integral = index + 1
            this.integralGap = (maxnum + 1) - num
          } else {
          }
        })
        // 头衔
        arr.map((item, index) => {
          let minnum = item.split('-')[0] - 0
          let maxnum = item.split('-')[1] - 0
          let units = item.split('-')[2]
          if (minnum <= this.integral && this.integral <= maxnum) {
            this.integralIcon = this.integral - (5 * index) + units
          } else {
          }
        })
      }
    },
    mounted () {
      // let id = util.cookie.get('baseId');
      // let _this = this;
      // util.kAjax(API.GETCUSTOMERINFO,{id:id},res=>{
      //     _this.userInfo = res.data;
      // });
      let _this = this
      this.$store.dispatch('getUserInfo')
        .then(res => {

        })
      // 订单
      util.kAjax(API.FINDMYORDER, {}, res => {
        res.data.datas.map(d => {
          d.realPath = ''
        })
        this.orderData = res.data.datas.slice(0, 3)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// HomeView.vue?40f69024